import { defineAsyncComponent } from 'vue'

export const ModalReportBug = defineAsyncComponent(() => import('../ModalReportBug/ModalReportBug.vue'))
